import { createFileRoute } from "@tanstack/react-router";

import { AdminErrorsPage } from "@/components/admin/AdminErrorsPage";

export const Route = createFileRoute("/administrator/errors")({
  head: () => ({ meta: [{ title: "Error Center · GENRL Admin" }] }),
  validateSearch: (raw: Record<string, unknown>) => ({
    incident: typeof raw.incident === "string" ? raw.incident : undefined,
    user_id: typeof raw.user_id === "string" ? raw.user_id : undefined,
  }),
  component: ErrorsRoute,
});

function ErrorsRoute() {
  const search = Route.useSearch();
  return <AdminErrorsPage initialIncidentID={search.incident} initialUserID={search.user_id} />;
}
